import {RoomDataType} from '../redux/types'; // REFACTOR TYPES

export default function getCgNoOfRoomFlavors(rooms: Array<RoomDataType>) {
  if (!rooms || !rooms.length) {
    return 0;
  }

  let roomFlavorsCount = 0;

  rooms?.forEach(room => {
    room?.ratePlans.forEach(roomFlavor => {
      roomFlavorsCount++;
    });
  });

  return roomFlavorsCount;
}
